module.exports = __webpack_public_path__ + "img/extendable_ears.e5f2017d.jpg";